import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type ExtraLayesPolar = {
  add_extraLayers: PolarYesNoUndefined;
};
type ExtraLayersChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof ExtraLayesPolar }) => void;
  polarQuestions: ExtraLayesPolar;
};
export default function ExtraLayersChecks({ onHandleYesNo, polarQuestions }: ExtraLayersChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you want to add extra layers?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "add_extraLayers" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "add_extraLayers" });
        }}
        selection={polarQuestions.add_extraLayers}
      />
    </>
  );
}
